import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import * as CPActions from '../../actions/contentPush'
import { ContentPush as ContentPushDOM } from '../../components/Screens'

class ContentPush extends PureComponent {
    static propTypes = {
        list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        searchContentPush: PropTypes.func.isRequired,
        selectedEstate: PropTypes.string.isRequired,
        fetchContentPushesGroup: PropTypes.func.isRequired,
        fetchContentPushesLevelRequired: PropTypes.func.isRequired,
        fetchContentPushesStatus: PropTypes.func.isRequired,
        contentPushStatus: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        contentPushGroups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        contentPushRequiredLevels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        changeContentPushFilters: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            search: '',
        }

        this.onChangeInput = this.onChangeInput.bind(this)
    }

    componentDidMount() {
        this.refreshFilters()
        this.refreshData()
    }

    componentDidUpdate(lastProps) {
        const { selectedEstate: lastEstateSelected } = lastProps
        const { selectedEstate: nextEstateSelected } = this.props

        if (lastEstateSelected !== nextEstateSelected) {
            this.refreshFilters()
            this.refreshData()
        }
    }

    // On Change any input value
    onChangeInput({ target: { name, value } }) {
        this.setState({ [name]: value }, this.search)
    }

    refreshData() {
        this.search()
    }

    isSelected = (item, array) => {
        const index = array.findIndex((itemInArray) => itemInArray.id === item.id && itemInArray.isSelected)
        return index
    }

    refreshFilters = async () => {
        const { fetchContentPushesGroup, fetchContentPushesLevelRequired, fetchContentPushesStatus } = this.props
        await Promise.all([fetchContentPushesStatus(), fetchContentPushesGroup(), fetchContentPushesLevelRequired()])
    }

    search() {
        const { searchContentPush, contentPushGroups: groups, contentPushStatus: stateStatusList, contentPushRequiredLevels: requiredLevels } = this.props
        const { search } = this.state
        const statusList = []
        stateStatusList.forEach((statusInList) => {
            const { id, selected } = statusInList
            if (selected) statusList.push(id)
        })
        const groupList = []
        groups.forEach((groupInList) => {
            const { id, selected } = groupInList
            if (selected) groupList.push(id)
        })
        const levelList = []
        requiredLevels.forEach((levelInList) => {
            const { id, selected } = levelInList
            if (selected) levelList.push(id)
        })
        searchContentPush({
            search,
            statusList,
            groupList,
            levelList,
        })
    }

    onSelectStatus = async (index) => {
        const { contentPushRequiredLevels, contentPushGroups, contentPushStatus, changeContentPushFilters } = this.props
        if (contentPushStatus[index]) {
            contentPushStatus[index].selected = !contentPushStatus[index].selected
            await changeContentPushFilters(contentPushStatus, contentPushGroups, contentPushRequiredLevels)
            this.search()
        }
    }

    onSelectLevel = async (index) => {
        const { contentPushRequiredLevels, contentPushGroups, contentPushStatus, changeContentPushFilters } = this.props
        if (contentPushRequiredLevels[index]) {
            contentPushRequiredLevels[index].selected = !contentPushRequiredLevels[index].selected
            await changeContentPushFilters(contentPushStatus, contentPushGroups, contentPushRequiredLevels)
            this.search()
        }
    }

    onSelectGroup = async (index) => {
        const { contentPushRequiredLevels, contentPushGroups, contentPushStatus, changeContentPushFilters } = this.props
        if (contentPushGroups[index]) {
            contentPushGroups[index].selected = !contentPushGroups[index].selected
            await changeContentPushFilters(contentPushStatus, contentPushGroups, contentPushRequiredLevels)
            this.search()
        }
    }

    render() {
        const { list, contentPushStatus, contentPushGroups, contentPushRequiredLevels } = this.props
        const { search } = this.state
        return (
            <ContentPushDOM
                data={list}
                onChangeSearch={this.onChangeInput}
                valueSearch={search}
                groups={contentPushGroups}
                requiredLevels={contentPushRequiredLevels}
                statusList={contentPushStatus}
                onSelectStatus={this.onSelectStatus}
                onSelectGroup={this.onSelectGroup}
                onSelectLevel={this.onSelectLevel}
            />
        )
    }
}

const mapStateToProps = ({
    app: { selectedEstate },
    contentPush: { list, contentPushStatus, contentPushGroups, contentPushRequiredLevels, changeContentPushFilters },
}) => ({
    selectedEstate,
    list,
    contentPushStatus,
    contentPushGroups,
    contentPushRequiredLevels,
    changeContentPushFilters,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...CPActions,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContentPush))
